import { collateErrors as collatePasswordErrors } from '@ynap/password-input';
import { raygun } from '@ynap/clientside-monitoring';

export default function collateErrors(values, props, json) {
    let errors = {};
    const { messages, registrationSectionName } = props;

    const passwordErrors = collatePasswordErrors(values, props, json);

    if (json && json.errors) {
        json.errors.forEach(({ errorKey, errorParameters }) => {
            switch (errorKey) {
                case '_ERR_LOGONID_ALREDY_EXIST':
                    raygun.helpers.agent('send', {
                        errorKey,
                        tags: ['GuestRegistration', 'Already existing'],
                    });
                    errors._error = errors.logonId = messages.errors.userExists();
                    break;
                case '_ERR_MISSING_CMD_PARAMETER':
                    raygun.helpers.agent('send', {
                        errorKey,
                        tags: ['GuestRegistration', 'Missing cmd parameter'],
                    });
                    errors._error = errors[errorParameters.split(',')[0]] = messages.errors.required({ field: errorParameters.split(',')[0] });
                    break;
                case '_ERR_VALUE_FOR_PARM_NOT_SUPPORTED':
                    raygun.helpers.agent('send', {
                        errorKey,
                        tags: ['GuestRegistration', 'Parameter not supported'],
                    });
                    errors._error = errors[errorParameters.split(',')[0]] = messages.errors.required({ field: errorParameters.split(',')[0] });
                    break;
                default:
                    raygun.helpers.agent('send', {
                        errorKey,
                        tags: ['GuestRegistration', 'Other'],
                    });
            }
        });
    }

    const _error = !Object.keys(errors).length && !Object.keys(passwordErrors).length ? messages.errors.global() : undefined;

    return { _error, ...errors, ...passwordErrors };
}
